import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'file-patterns',
    pluginName: 'SETTINGS',
    entityName: 'FILE_PATTERN',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// Fetch file patterns action creators
export const fetchFilePatternInit = () => {
    return crudActions.fetchInit();
};
export const fetchFilePatternStart = () => {
    return crudActions.fetchStart();
};
export const fetchFilePatternSuccess = (fetchFilePatternCount, listFilePatternCount) => {
    return crudActions.fetchSuccess(fetchFilePatternCount, listFilePatternCount);
};
export const fetchFilePatternFail = () => {
    return crudActions.fetchFail();
};
export const fetchFilePatternCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchFilePatternStart());
        try {
            let countRes = await rest.post("file-patterns/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchFilePatternSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchFilePatternFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch  file patterns."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchFilePatternFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch  file patterns."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchFilePattern = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchFilePatternStart());
        try {
            let listRes = await rest.post("file-patterns/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchFilePatternSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchFilePatternFail());
            return []

        } catch (error) {
            dispatch(fetchFilePatternFail());
            return []
        }
    }
}

// Load file pattern action creators
export const loadFilePatternInit = () => {
    return crudActions.loadInit();
};
export const loadFilePatternStart = () => {
    return crudActions.loadStart();
};
export const loadFilePatternSuccess = loadedFilePattern => {
    return crudActions.loadSuccess(loadedFilePattern);
};
export const loadFilePatternFail = error => {
    return crudActions.loadFail(error);
};
export const loadFilePattern = id => {
    return async dispatch => {
        await crudActions.load(dispatch, id);
    };
};

export const createFilePattern = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/file-patterns/create', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully created file pattern.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create file pattern."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

export const editFilePattern = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/file-patterns/save', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated file pattern.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit file pattern."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Bulk delete file patterns action creators
export const bulkDeleteFilePatternsInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteFilePatternsStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteFilePatternsSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteFilePatternsFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteFilePatterns = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteFilePatternsStart());
        try {
            let res = await rest.post('/file-patterns/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteFilePatternsSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted file patterns.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteFilePatternsFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete file patterns."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete file patterns."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteFilePatternsFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}